export interface RefreshPlanType {
  key: string;
  name: string;
  description: string;
  cost: number;
  selectable?: boolean;
  upgradeMethod: 'none' | 'user' | 'sales';
  features: Array<string>;
  weight: number;
  primaryColor: string;
  secondaryColor: string;
}

const Plans: { plans: { TYPES: RefreshPlanType[] } } = {
  plans:  {
    TYPES: [
      {
        key: "essential",
        name: 'Essential',
        cost: 10,
        description: 'All the basics to jump-start your fee-based business with confidence',
        features: ['1 advisor', 'Up to 10 clients', 'One-time and recurring invoices', 'Accept card and ACH payments', 'AdvicePay logo'],
        selectable: true,
        upgradeMethod: 'user',
        weight: 1,
        primaryColor: "#262425",
        secondaryColor: '#E5E2DF'
      },
      {
        key: "professional",
        name: 'Professional',
        cost: 50,
        description: 'Advanced capabilities for growth-oriented advisors and ensemble firms',
        features: ['Unlimited advisors and admins', 'Unlimited clients', 'One-time and recurring invoices', 'Accept card and ACH payments', 'Custom logo', 'Integrate with industry-leading tools'],
        selectable: true,
        upgradeMethod: 'user',
        weight: 2,
        primaryColor: "#215168",
        secondaryColor: '#eff5fb'
      },
      {
        key: "enterprise",
        name: 'Enterprise',
        cost: 2500,
        description: 'Scalable operations for enterprise home offices and their advisors',
        features: ['All Professional features', 'Mobile check deposit', 'Custom Engagement workflows', 'Deliverables', 'Integrate with indusry-leading tools', 'API access', 'Dedicated customer success manager'],
        selectable: true,
        upgradeMethod: 'sales',
        weight: 3,
        primaryColor: "#1a4724",
        secondaryColor: '#f9fbee'
      },
      {
        key: "enterprise_advisor",
        name: 'Enterprise Rep',
        cost: 65,
        description: 'Contact your account owner or support@advicepay.com for more info',
        features: ["Recurring Billing for Various Frequencies", "Compliant Workflows", "eSignature for Client Documents", "Flexible Invoicing Options", "Accept Credit Cards or ACH for Client Payments"],
        upgradeMethod: 'none',
        weight: 4,
        primaryColor: "#1a4724",
        secondaryColor: '#f9fbee'
      }
    ]
  }
}

export default Plans;
